import React, { forwardRef, useImperativeHandle, useState } from 'react'
// import PropTypes from 'prop-types'

import { CloseIcon } from 'components/Icons'

import { CloseButton, ContentWrapper, Overlay, Wrapper } from './Modal.style'

// forwardRef doesnt accept propTypes, hence this is disabled
// eslint-disable-next-line react/prop-types
const Modal = ({ children, defaultOpen = false }, ref) => {
  const [isClosing, setIsClosing] = useState(false)
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const handleClose = () => {
    setIsClosing(true)

    setTimeout(() => {
      setIsClosing(false)
      setIsOpen(false)
      // @ts-ignore
      window.modalIsOpened = false
    }, 300)
  }

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true)
      // @ts-ignore
      window.modalIsOpened = true
    },
  }))

  if (!isOpen) return null

  return (
    <Overlay isClosing={isClosing} onClick={handleClose}>
      <Wrapper>
        <div>
          <CloseButton type="button" onClick={handleClose}>
            <CloseIcon width={[20]} />
          </CloseButton>
        </div>
        <ContentWrapper>{children}</ContentWrapper>
      </Wrapper>
    </Overlay>
  )
}

// Modal.propTypes = {
//   children: PropTypes.node.isRequired,
//   defaultOpen: PropTypes.bool.isRequired,
// }

export default forwardRef(Modal)
